<ng-container [formGroup]="form">
  <!-- Deprecated -->
  <div class="form-check">
    <input
      class="form-check-input"
      [formErrors]="['lifecycleInvalid']"
      [id]="id + '_deprecated'"
      [noIsValid]="true"
      (change)="setPreview()"
      formControlName="deprecated"
      name="deprecated"
      portalInputValidityState
      type="checkbox"
    />

    <label class="form-check-label" [for]="id + '_deprecated'">
      {{ 'download.deprecated' | portalTranslate }}
    </label>
  </div>

  <!-- Preview -->
  <div class="form-check">
    <input
      class="form-check-input"
      [formErrors]="['lifecycleInvalid']"
      [id]="id + '_preview'"
      [noIsValid]="true"
      (change)="setDeprecated()"
      formControlName="preview"
      name="preview"
      portalInputValidityState
      type="checkbox"
    />

    <label class="form-check-label" [for]="id + '_preview'">
      {{ 'download.preview' | portalTranslate }}
    </label>
  </div>

  @if (form.errors?.['lifecycleInvalid'] != null) {
    <div class="invalid-feedback" [innerHTML]="form.errors['lifecycleInvalid'].key | portalTranslate"></div>
  }
</ng-container>
